const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            width: {
                type: 'number',
            },
            height: {
                type: 'number',
            },
            borderWidth: {
                type: 'number',
            },
            borderRadius: {
                type: 'number',
            },
            borderColor: {
                type: 'string',
            },
            backgroundColor: {
                type: 'string',
            },
            textMarginHorizontal: {
                type: 'number',
            },
            textColor: {
                type: 'string',
            },
            textFontFamily: {
                type: 'string',
            },
            textFontSize: {
                type: 'number',
            },
            textFontWeight: {
                type: 'string',
            },
            iconWidth: {
                type: 'number',
            },
            iconHeight: {
                type: 'number',
            },
            iconTintColor: {
                type: 'string',
            },
            outlineWidth: {
                type: 'number',
            },
            outlineHeight: {
                type: 'number',
            },
            outlineBorderRadius: {
                type: 'number',
            },
            outlineBackgroundColor: {
                type: 'string',
            },
            containerBorderRadius: {
                type: 'number',
            },
            containerBorderWidth: {
                type: 'number',
            },
            containerBorderColor: {
                type: 'string',
            },
            containerPaddingLeft: {
                type: 'number',
            },
            containerPaddingRight: {
                type: 'number',
            },
            containerPaddingVertical: {
                type: 'number',
            },
        },
        appearances: {
            default: {
                default: true,
            },
            outline: {
                default: false,
            },
        },
        variantGroups: {
            status: {
                primary: {
                    default: false,
                },
                success: {
                    default: false,
                },
                warning: {
                    default: false,
                },
                danger: {
                    default: false,
                },
                info: {
                    default: false,
                },
                basic: {
                    default: true,
                },
                control: {
                    default: false,
                },
            },
            context: {
                altBg: {
                    default: false,
                },
            },
        },
        states: {
            checked: {
                default: false,
                priority: 0,
                scope: 'all',
            },
            hover: {
                default: false,
                priority: 1,
                scope: 'all',
            },
            disabled: {
                default: false,
                priority: 2,
                scope: 'all',
            },
            active: {
                default: false,
                priority: 3,
                scope: 'all',
            },
            indeterminate: {
                default: false,
                priority: 4,
                scope: 'all',
            },
            focused: {
                default: false,
                priority: 5,
                scope: 'all',
            },
        },
    },
    appearances: {
        default: {
            mapping: {
                width: 20,
                height: 20,
                borderRadius: 3,
                borderWidth: 2,
                outlineWidth: 32,
                outlineHeight: 32,
                outlineBorderRadius: 6,
                outlineBackgroundColor: 'transparent',
                textFontSize: 'text-subtitle-2-font-size',
                textFontWeight: 'text-subtitle-2-font-weight',
                textFontFamily: 'text-subtitle-2-font-family',
                textMarginHorizontal: 12,
                iconWidth: 14,
                iconHeight: 14,
                iconTintColor: 'transparent',
            },
            variantGroups: {
                status: {
                    basic: {
                        borderColor: 'color-primary-700',
                        backgroundColor: 'color-basic-transparent-default',
                        textColor: 'text-basic-color',
                        state: {
                            checked: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-primary-transparent-focus-border',
                                backgroundColor: 'color-primary-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-primary-focus-border',
                                backgroundColor: 'color-primary-focus',
                            },
                            hover: {
                                borderColor: 'color-primary-transparent-hover-border',
                                backgroundColor: 'color-primary-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-primary-hover-border',
                                backgroundColor: 'color-primary-hover',
                            },
                            active: {
                                borderColor: 'color-primary-transparent-active-border',
                                backgroundColor: 'color-primary-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-primary-active-border',
                                backgroundColor: 'color-primary-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                                outlineBackgroundColor: 'outline-color',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    primary: {
                        borderColor: 'color-primary-transparent-default-border',
                        backgroundColor: 'color-primary-transparent-default',
                        textColor: 'text-basic-color',
                        state: {
                            checked: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-primary-transparent-focus-border',
                                backgroundColor: 'color-primary-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-primary-focus-border',
                                backgroundColor: 'color-primary-focus',
                            },
                            hover: {
                                borderColor: 'color-primary-transparent-hover-border',
                                backgroundColor: 'color-primary-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-primary-hover-border',
                                backgroundColor: 'color-primary-hover',
                            },
                            active: {
                                borderColor: 'color-primary-transparent-active-border',
                                backgroundColor: 'color-primary-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-primary-active-border',
                                backgroundColor: 'color-primary-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    success: {
                        borderColor: 'color-success-transparent-default-border',
                        backgroundColor: 'color-success-transparent-default',
                        textColor: 'text-basic-color',
                        state: {
                            checked: {
                                borderColor: 'color-success-default-border',
                                backgroundColor: 'color-success-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-success-default-border',
                                backgroundColor: 'color-success-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-success-transparent-focus-border',
                                backgroundColor: 'color-success-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-success-focus-border',
                                backgroundColor: 'color-success-focus',
                            },
                            hover: {
                                borderColor: 'color-success-transparent-hover-border',
                                backgroundColor: 'color-success-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-success-hover-border',
                                backgroundColor: 'color-success-hover',
                            },
                            active: {
                                borderColor: 'color-success-transparent-active-border',
                                backgroundColor: 'color-success-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-success-active-border',
                                backgroundColor: 'color-success-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    info: {
                        borderColor: 'color-info-transparent-default-border',
                        backgroundColor: 'color-info-transparent-default',
                        textColor: 'text-basic-color',
                        state: {
                            checked: {
                                borderColor: 'color-info-default-border',
                                backgroundColor: 'color-info-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-info-default-border',
                                backgroundColor: 'color-info-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-info-transparent-focus-border',
                                backgroundColor: 'color-info-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-info-focus-border',
                                backgroundColor: 'color-info-focus',
                            },
                            hover: {
                                borderColor: 'color-info-transparent-hover-border',
                                backgroundColor: 'color-info-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-info-hover-border',
                                backgroundColor: 'color-info-hover',
                            },
                            active: {
                                borderColor: 'color-info-transparent-active-border',
                                backgroundColor: 'color-info-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-info-active-border',
                                backgroundColor: 'color-info-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    warning: {
                        borderColor: 'color-warning-transparent-default-border',
                        backgroundColor: 'color-warning-transparent-default',
                        textColor: 'text-basic-color',
                        state: {
                            checked: {
                                borderColor: 'color-warning-default-border',
                                backgroundColor: 'color-warning-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-warning-default-border',
                                backgroundColor: 'color-warning-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-warning-transparent-focus-border',
                                backgroundColor: 'color-warning-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-warning-focus-border',
                                backgroundColor: 'color-warning-focus',
                            },
                            hover: {
                                borderColor: 'color-warning-transparent-hover-border',
                                backgroundColor: 'color-warning-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-warning-hover-border',
                                backgroundColor: 'color-warning-hover',
                            },
                            active: {
                                borderColor: 'color-warning-transparent-active-border',
                                backgroundColor: 'color-warning-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-warning-active-border',
                                backgroundColor: 'color-warning-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    danger: {
                        borderColor: 'color-danger-transparent-default-border',
                        backgroundColor: 'color-danger-transparent-default',
                        textColor: 'text-basic-color',
                        state: {
                            checked: {
                                borderColor: 'color-danger-default-border',
                                backgroundColor: 'color-danger-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-danger-default-border',
                                backgroundColor: 'color-danger-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-danger-transparent-focus-border',
                                backgroundColor: 'color-danger-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-danger-focus-border',
                                backgroundColor: 'color-danger-focus',
                            },
                            hover: {
                                borderColor: 'color-danger-transparent-hover-border',
                                backgroundColor: 'color-danger-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-danger-hover-border',
                                backgroundColor: 'color-danger-hover',
                            },
                            active: {
                                borderColor: 'color-danger-transparent-active-border',
                                backgroundColor: 'color-danger-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-danger-active-border',
                                backgroundColor: 'color-danger-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    control: {
                        borderColor: 'color-control-transparent-default-border',
                        backgroundColor: 'color-control-transparent-default',
                        textColor: 'text-control-color',
                        state: {
                            checked: {
                                borderColor: 'color-control-default-border',
                                backgroundColor: 'color-control-default',
                                iconTintColor: 'color-basic-800',
                            },
                            indeterminate: {
                                borderColor: 'color-control-default-border',
                                backgroundColor: 'color-control-default',
                                iconTintColor: 'color-basic-800',
                            },
                            focused: {
                                borderColor: 'color-control-transparent-focus-border',
                                backgroundColor: 'color-control-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-control-focus-border',
                                backgroundColor: 'color-control-focus',
                            },
                            hover: {
                                borderColor: 'color-control-transparent-hover-border',
                                backgroundColor: 'color-control-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-control-hover-border',
                                backgroundColor: 'color-control-hover',
                            },
                            active: {
                                borderColor: 'color-control-transparent-active-border',
                                backgroundColor: 'color-control-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-control-active-border',
                                backgroundColor: 'color-control-active',
                            },
                            disabled: {
                                borderColor: 'color-control-transparent-disabled-border',
                                backgroundColor: 'color-control-transparent-disabled',
                                textColor: 'text-control-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                                iconTintColor: 'text-control-color',
                            },
                        },
                    },
                },
                context: {
                    altBg: {
                        backgroundColor: 'white',
                        state: {
                            hover: {
                                borderColor: 'color-primary-transparent-hover-border',
                                backgroundColor: 'white',
                            },
                        },
                    },
                },
            },
        },
        outline: {
            mapping: {
                width: 20,
                height: 20,
                containerBorderWidth: 1,
                containerBorderColor: 'color-flat-400',
                containerBorderRadius: 4,
                containerPaddingLeft: 8,
                containerPaddingRight: 0,
                containerPaddingVertical: 8,
                borderRadius: 3,
                borderWidth: 2,
                outlineWidth: 32,
                outlineHeight: 32,
                outlineBorderRadius: 6,
                outlineBackgroundColor: 'transparent',
                textFontSize: 'text-caption-1-font-size',
                textFontWeight: 'text-caption-1-font-weight',
                textFontFamily: 'text-font-family',
                textMarginHorizontal: 8,
                iconWidth: 14,
                iconHeight: 14,
                iconTintColor: 'transparent',
            },
            variantGroups: {
                status: {
                    basic: {
                        borderColor: 'color-primary-700',
                        backgroundColor: 'color-basic-transparent-default',
                        textColor: 'color-flat-700',
                        state: {
                            checked: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-primary-transparent-focus-border',
                                backgroundColor: 'color-primary-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-primary-focus-border',
                                backgroundColor: 'color-primary-focus',
                            },
                            hover: {
                                borderColor: 'color-primary-transparent-hover-border',
                                backgroundColor: 'color-primary-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-primary-hover-border',
                                backgroundColor: 'color-primary-hover',
                            },
                            active: {
                                borderColor: 'color-primary-transparent-active-border',
                                backgroundColor: 'color-primary-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-primary-active-border',
                                backgroundColor: 'color-primary-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    primary: {
                        borderColor: 'color-primary-transparent-default-border',
                        backgroundColor: 'color-primary-transparent-default',
                        textColor: 'color-flat-700',
                        state: {
                            checked: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-primary-500',
                                backgroundColor: 'color-primary-500',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-primary-transparent-focus-border',
                                backgroundColor: 'color-primary-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-primary-focus-border',
                                backgroundColor: 'color-primary-focus',
                            },
                            hover: {
                                borderColor: 'color-primary-transparent-hover-border',
                                backgroundColor: 'color-primary-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-primary-hover-border',
                                backgroundColor: 'color-primary-hover',
                            },
                            active: {
                                borderColor: 'color-primary-transparent-active-border',
                                backgroundColor: 'color-primary-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-primary-active-border',
                                backgroundColor: 'color-primary-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    success: {
                        borderColor: 'color-success-transparent-default-border',
                        backgroundColor: 'color-success-transparent-default',
                        textColor: 'color-flat-700',
                        state: {
                            checked: {
                                borderColor: 'color-success-default-border',
                                backgroundColor: 'color-success-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-success-default-border',
                                backgroundColor: 'color-success-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-success-transparent-focus-border',
                                backgroundColor: 'color-success-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-success-focus-border',
                                backgroundColor: 'color-success-focus',
                            },
                            hover: {
                                borderColor: 'color-success-transparent-hover-border',
                                backgroundColor: 'color-success-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-success-hover-border',
                                backgroundColor: 'color-success-hover',
                            },
                            active: {
                                borderColor: 'color-success-transparent-active-border',
                                backgroundColor: 'color-success-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-success-active-border',
                                backgroundColor: 'color-success-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    info: {
                        borderColor: 'color-info-transparent-default-border',
                        backgroundColor: 'color-info-transparent-default',
                        textColor: 'color-flat-700',
                        state: {
                            checked: {
                                borderColor: 'color-info-default-border',
                                backgroundColor: 'color-info-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-info-default-border',
                                backgroundColor: 'color-info-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-info-transparent-focus-border',
                                backgroundColor: 'color-info-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-info-focus-border',
                                backgroundColor: 'color-info-focus',
                            },
                            hover: {
                                borderColor: 'color-info-transparent-hover-border',
                                backgroundColor: 'color-info-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-info-hover-border',
                                backgroundColor: 'color-info-hover',
                            },
                            active: {
                                borderColor: 'color-info-transparent-active-border',
                                backgroundColor: 'color-info-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-info-active-border',
                                backgroundColor: 'color-info-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    warning: {
                        borderColor: 'color-warning-transparent-default-border',
                        backgroundColor: 'color-warning-transparent-default',
                        textColor: 'color-flat-700',
                        state: {
                            checked: {
                                borderColor: 'color-warning-default-border',
                                backgroundColor: 'color-warning-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-warning-default-border',
                                backgroundColor: 'color-warning-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-warning-transparent-focus-border',
                                backgroundColor: 'color-warning-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-warning-focus-border',
                                backgroundColor: 'color-warning-focus',
                            },
                            hover: {
                                borderColor: 'color-warning-transparent-hover-border',
                                backgroundColor: 'color-warning-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-warning-hover-border',
                                backgroundColor: 'color-warning-hover',
                            },
                            active: {
                                borderColor: 'color-warning-transparent-active-border',
                                backgroundColor: 'color-warning-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-warning-active-border',
                                backgroundColor: 'color-warning-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    danger: {
                        borderColor: 'color-danger-transparent-default-border',
                        backgroundColor: 'color-danger-transparent-default',
                        textColor: 'color-flat-700',
                        state: {
                            checked: {
                                borderColor: 'color-danger-default-border',
                                backgroundColor: 'color-danger-default',
                                iconTintColor: 'text-control-color',
                            },
                            indeterminate: {
                                borderColor: 'color-danger-default-border',
                                backgroundColor: 'color-danger-default',
                                iconTintColor: 'text-control-color',
                            },
                            focused: {
                                borderColor: 'color-danger-transparent-focus-border',
                                backgroundColor: 'color-danger-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-danger-focus-border',
                                backgroundColor: 'color-danger-focus',
                            },
                            hover: {
                                borderColor: 'color-danger-transparent-hover-border',
                                backgroundColor: 'color-danger-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-danger-hover-border',
                                backgroundColor: 'color-danger-hover',
                            },
                            active: {
                                borderColor: 'color-danger-transparent-active-border',
                                backgroundColor: 'color-danger-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-danger-active-border',
                                backgroundColor: 'color-danger-active',
                            },
                            disabled: {
                                borderColor: 'color-basic-transparent-disabled-border',
                                backgroundColor: 'color-basic-transparent-disabled',
                                textColor: 'text-disabled-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                            },
                        },
                    },
                    control: {
                        borderColor: 'color-control-transparent-default-border',
                        backgroundColor: 'color-control-transparent-default',
                        textColor: 'color-flat-700',
                        state: {
                            checked: {
                                borderColor: 'color-control-default-border',
                                backgroundColor: 'color-control-default',
                                iconTintColor: 'color-basic-800',
                            },
                            indeterminate: {
                                borderColor: 'color-control-default-border',
                                backgroundColor: 'color-control-default',
                                iconTintColor: 'color-basic-800',
                            },
                            focused: {
                                borderColor: 'color-control-transparent-focus-border',
                                backgroundColor: 'color-control-transparent-focus',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.focused': {
                                borderColor: 'color-control-focus-border',
                                backgroundColor: 'color-control-focus',
                            },
                            hover: {
                                borderColor: 'color-control-transparent-hover-border',
                                backgroundColor: 'color-control-transparent-hover',
                            },
                            'checked.hover': {
                                borderColor: 'color-control-hover-border',
                                backgroundColor: 'color-control-hover',
                            },
                            active: {
                                borderColor: 'color-control-transparent-active-border',
                                backgroundColor: 'color-control-transparent-active',
                                outlineBackgroundColor: 'outline-color',
                            },
                            'checked.active': {
                                borderColor: 'color-control-active-border',
                                backgroundColor: 'color-control-active',
                            },
                            disabled: {
                                borderColor: 'color-control-transparent-disabled-border',
                                backgroundColor: 'color-control-transparent-disabled',
                                textColor: 'text-control-color',
                            },
                            'checked.disabled': {
                                borderColor: 'color-basic-transparent-600',
                                backgroundColor: 'color-basic-transparent-600',
                                iconTintColor: 'text-control-color',
                            },
                        },
                    },
                },
                context: {
                    altBg: {
                        backgroundColor: 'white',
                        state: {
                            hover: {
                                borderColor: 'color-primary-transparent-hover-border',
                                backgroundColor: 'white',
                            },
                        },
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNACheckbox.theme.alucio.js.map